<div *ngIf="placementsList$ | async as placements">
    <jobs-placements-list-of-placements [placements]="placements" (selectPlacement)="select($event)">
        <jobs-placements-list-item-text *ngIf="emptyText" [isShow]="placements.length < 3" [text]="emptyText">
        </jobs-placements-list-item-text>
    </jobs-placements-list-of-placements>
</div>